import React, { createContext, useContext } from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
import config from "../config";

// Inicializa o app Firebase (apenas se ainda não foi inicializado)
if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

// Obtém os serviços
const database = firebase.database();
const firestore = firebase.firestore();

// Contexto para Firebase
const FirebaseContext = createContext<{
  database: firebase.database.Database;
  firestore: firebase.firestore.Firestore;
} | null>(null);

const FirebaseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <FirebaseContext.Provider value={{ database, firestore }}>
      {children}
    </FirebaseContext.Provider>
  );
};

function useFirebase() {
  const context = useContext(FirebaseContext);

  if (!context) {
    throw new Error('useFirebase must be used within a FirebaseProvider');
  }

  return context;
}

export { FirebaseProvider, useFirebase, database, firestore };
